import clsx from "clsx";
import type { SortDir } from "@/lib/bookingTableUtils";

export interface SortableTableHeaderProps {
  label: string;
  active: boolean;
  direction: SortDir;
  onSort: () => void;
  className?: string;
  align?: "left" | "right";
}

export function SortableTableHeader({
  label,
  active,
  direction,
  onSort,
  className,
  align = "left",
}: SortableTableHeaderProps) {
  return (
    <th className={clsx(align === "right" && "text-right", className)}>
      <button
        type="button"
        className={clsx(
          "inline-flex items-center gap-1 rounded-md px-1 py-0.5 text-left font-medium transition-colors",
          "hover:bg-fill-tertiary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/40",
          align === "right" && "ml-auto",
        )}
        onClick={onSort}
        aria-sort={active ? (direction === "asc" ? "ascending" : "descending") : "none"}
      >
        <span>{label}</span>
        <span
          className={clsx(
            "text-[0.65rem] leading-none",
            active ? "text-accent" : "text-label-tertiary",
          )}
          aria-hidden
        >
          {active ? (direction === "asc" ? "▲" : "▼") : "↕"}
        </span>
      </button>
    </th>
  );
}
